export const cloudfrontUrlMap: Record<string, string> = {
  // Assets
  'brandlive-upload.s3-us-west-2.amazonaws.com': 'assets.brandlive.com',
};

export const getCloudfrontUrl = (url: string): string => {
  try {
    const urlObject = new URL(url);

    if (urlObject.hostname in cloudfrontUrlMap) {
      urlObject.hostname = cloudfrontUrlMap[urlObject.hostname];
    }

    return urlObject.toString();
  } catch {
    return url;
  }
};
